





































































































































































































































































































































































































































































import AddUpdateEntityLocation from '@/components/add business objects/addUpdateEntityLocation.vue';
import { Component, Prop, PropSync, Vue, Emit } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	ProductType,
	ProductsApi,
	Transceiver,
	WaterMeter,
	WaterMonitor,
	WaterMetersApi,
	WaterMonitorsApi,
	WaterTank,
	WaterTanksApi,
	SimproJobDetails,
	Product,
	ProductSimProJobTypeEnum,
	Entities,
} from '@/api';
import TankChartAdmin from '@/components/charts/tank-chart.vue';
import DataTable from '@/components/datatable.vue';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import WaterEntityChartAdmin from '@/components/charts/water-entity-chart.vue';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import WaterEntityInstallModal from '@/pages/account/products/water/entity/install.vue';
import WaterEntityProvisionModal from '@/pages/account/products/water/entity/provision.vue';
import Notifications from '@/components/tables/notifications.vue';
import EventSubscriptionChangeLog from '@/components/tables/event-subscription-change-log.vue';

import EventSubscriptions from '@/components/tables/event-subscriptions.vue';
import ManageEventSubscriptions from '@/components/manage-event-subscriptions.vue';
import DeletedEventSubscriptionAudits from '@/components/tables/deletedEventSubscriptionAudits.vue';
import TotalizerCorrectionsTab from './TotalizerCorrectionsTab.vue';
import TotalizerChart from './TotalizerChart.vue';
import { isWaterMeterEntity } from '@/common/Validators';
import LocationRow from '@/components/display/information-rows/location-row.vue';
import { WaterEntityUtil } from '@/common/WaterEntityUtil';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import LiveAtRow from '@/components/display/information-rows/live-at-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { isLastEntityOnProduct } from '@/common/EntityUtils';
import {
	StatusChangeReasonsCancel,
	StatusChangeReasonsLastEntity,
	StatusChangeReasonsRemoval,
} from '@/common/Constants';
import { WaterCorrectionsService } from '@/services/water-corrections-service';
import SentAlertCounts from '@/components/display/sentAlertCounts.vue';
import ConfirmDraftActionbar from '@/components/confirm-draft-actionbar.vue';
import { formattedStatus } from '@/common/StatusUtil';
import WaterFlowCurrentStatus from '@/components/charts/WaterFlowCurrentStatus.vue';
import WaterTankCurrentStatus from '@/components/charts/WaterTankCurrentStatus.vue';
import { getAlertText, showHelpTexts, getEntityButtonsText } from '@/common/HelpTextUtils';
import RouteTab from '@/components/RouteTab.vue';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';

@Component({
	computed: {
		ProductType() {
			return ProductType;
		},
	},
	components: {
		RouteTab,
		AddUpdateEntityLocation,
		WaterTankCurrentStatus,
		WaterFlowCurrentStatus,
		ChangelogLink,
		LastCheckInTag,
		LiveAtRow,
		LocationRow,
		DeletedEventSubscriptionAudits,
		RouterLinkButton,
		WaterEntityChartAdmin,
		secondaryNav,
		TankChartAdmin,
		DataTable,
		Toast,
		DataTableWithFilters,
		infoTabs,
		WaterEntityProvisionModal,
		WaterEntityInstallModal,
		ConfirmModal,
		Notifications,
		EventSubscriptionChangeLog,
		EventSubscriptions,
		ManageEventSubscriptions,
		TotalizerCorrectionsTab,
		TotalizerChart,
		SentAlertCounts,
		ConfirmDraftActionbar,
		TooltipButton,
	},
	mixins: [TitleMixin],
	methods: {
		getEntityButtonsText,
		isWaterMeterEntity,
		formattedStatus,
		getAlertText,
		showHelpTexts,
	},
})
export default class WaterEntityView extends Vue {
	public get routePrefix(): string {
		return `products.water.${this.entityType}.detail`;
	}

	public get entityTypeDisplayString(): string {
		return this.EntityNames[this.entityType] || '';
	}
	public entity: (WaterTank | WaterMeter | WaterMonitor) & { entitystatuschanges: any[] } = null;
	@Prop()
	public product!: Product;
	@Prop(Number)
	public entityId?: number;
	@Prop(String)
	public entityType?: string;
	@Prop()
	public productPlan?: string;
	@Prop()
	public simproJobs?: SimproJobDetails[];

	public parentLocations = [];
	public currentPage = 1;
	public perPage = 20;
	public loading = true;
	public org: any | null = null;
	public notifications: any | null = null;
	public entityCorrections: any[] = [];

	public transceiverFields: any[] | null = [
		{ key: 'transceiver.id', label: 'Id', sortable: true },
		{ key: 'label', label: 'Vat', sortable: true },
		{ key: 'transceiver.createdAt', label: 'Created', sortable: true },
		{ key: 'transceiver.serialNumber', label: 'Serial Number', sortable: true },
		{ key: 'transceiver.imei', label: 'IMEI', sortable: true },
	];

	public waterEntityTableDict = {
		tank: 'water_tanks',
		monitor: 'water_monitors',
		meter: 'water_meters',
	};

	public faults: any | null = null;
	public inputs: any | null = null;

	public sentAlerts = [];
	public sentAlertsFields = [
		{ key: 'user.email', label: 'Sent To', sortable: true },
		{ key: 'data.eventTypeDisplayName', label: 'Name', sortable: false },
		{ key: 'data.channel', label: 'Channels', sortable: false },
		{ key: 'created_at', label: 'Date Sent', sortable: true },
	];

	public form = { type: '', users: [], notes: '', status: null };

	public users: any[] | null = null;
	public audits: any[] | null = null;
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public entitySeries = {
		water_meters: [
			{ series: 'totalVolume', title: 'Total Usage (L)', processor: (val: any) => val },
			{ series: 'val', title: 'Flow Rate (L/min)', processor: (val: any) => val },
			{ series: 'volume', title: 'Volume Change (L)', processor: (val: any) => val },
		],
		water_tanks: [
			{ series: 'percent', title: 'Percent (%)', processor: (val: any) => val },
			{
				series: 'percent',
				title: 'Volume (L)',
				processor: (val: any) => this.doTankVolumeCalculation(val),
				hidden: true,
			}, // uses the "percent" time series
			{ series: 'val', title: 'Height (mm)', processor: (val: any) => val, hidden: true },
		],
		water_monitors: [
			{ series: 'totalVolume', title: 'Total Usage (L)', processor: (val: any) => val },
			{ series: 'val', title: 'Flow Rate (L/min)', processor: (val: any) => val },
			{ series: 'volume', title: 'Volume Change (L)', processor: (val: any) => val },
		],
	};

	public signurl;

	public token = this.$auth.token();

	public filters?: any;

	public next = '';
	public prev = '';
	public rawData: any[] | null = [];

	public generalInfo: any[] = [];
	private waterMetersApi: WaterMetersApi = new WaterMetersApi();
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();
	private toast = new Toast();

	private EntityNames: any = {
		water_meters: 'Supply',
		water_tanks: 'Storage',
		water_monitors: 'Usage',
	};

	@Emit('reload')
	public reload(): void {}

	public handleSignOff() {
		this.$bvModal.show(`sign-off-modal-${this.entityType}-${this.entityId}`);
	}

	public handleInstall() {
		this.$bvModal.show(`Install ${this.entityTypeDisplayString}Modal${this.entity.id}`);
	}

	public handleProvision() {
		this.$bvModal.show(`Provision ${this.entityTypeDisplayString}Modal${this.entity.id}`);
	}

	public handleHardware() {
		this.$bvModal.show(`Change ${this.entityTypeDisplayString} HardwareModal${this.entity.id}`);
	}

	public handleEdit() {
		this.$bvModal.show(`Edit ${this.entityTypeDisplayString}Modal${this.entity.id}`);
	}

	public handleCancel() {
		this.$bvModal.show(`cancel-modal-${this.entityType}-${this.entityId}`);
	}

	public handleRemove() {
		this.$bvModal.show(`remove-modal-${this.entityType}-${this.entityId}`);
	}

	public doTankVolumeCalculation(val: any) {
		return (this.entity.nominal || 1) * (val * 0.01);
	}

	public pageTitle() {
		return `Water | ${this.product ? this.product.name : ''}`;
	}

	public async loadEntity() {
		try {
			let data: any;
			const id = this.entityId;
			const params = {
				params: {
					include:
						'product.site,transceiver.site,sensor.node.transceiver.site,sensor.transceiver.site,audits.user,files,entitylocation,entitystatuschanges',
				},
			};

			switch (this.entityType) {
				case 'water_meters':
					data = (await this.waterMetersApi.getWaterMeterById(id, params)).data;
					break;
				case 'water_tanks':
					data = (await this.waterTanksApi.getWaterTankById(id, params)).data;
					break;
				case 'water_monitors':
					data = (await this.waterMonitorsApi.getWaterMonitorById(id, params)).data;
					break;
			}
			this.entity = data;
			this.org = data.org || {};
			this.parentLocations = [];

			if (this.entity && this.entity.entitylocation) {
				this.parentLocations.push({
					entityType: this.entityTypeAlternate,
					latitude: this.entity.entitylocation.latitude,
					longitude: this.entity.entitylocation.longitude,
				});
			}
			if (this.entity.product.site && this.entity.product.site.latitude) {
				this.parentLocations.push({
					type: 'Site',
					latitude: this.entity.product.site.latitude,
					longitude: this.entity.product.site.longitude,
				});
				if (this.entity.entitylocation === null) {
					this.entity.entitylocation = {
						id: null,
						entityId: this.entity.id,
						entityType: this.entityTypeAlternate,
						latitude: null,
						longitude: null,
						notes: null,
					};
				}
			}

			if (this.entityType && isWaterMeterEntity(this.entityType)) {
				const corrections = await WaterCorrectionsService.getTotalizerCorrections(
					this.entityType,
					this.entityId,
				);
				if (corrections?.error)
					this.toast.makeToast(corrections.error, 'Error Getting Corrections', 'danger');
				else this.entityCorrections = corrections.data ?? [];
			}

			if (this.entity != null) {
				this.generalInfo = [
					{ text: 'Status', value: this.entity.status || '' },
					{ text: this.entityTypeDisplayString + ' Name', value: this.entity.name },
					{ text: 'Product', value: this.product.name || '' },
					{ text: 'Site', value: this.product.site.name || '' },
					{ text: 'Created At', value: this.entity.createdAt },
					{
						text: 'Transceiver',
						value:
							this.entity && this.entity.transceiver ? this.entity.transceiver.serialNumber : '',
					},
					{
						text: 'Sensor',
						value: this.entity && this.entity.sensor ? this.entity.sensor.serialNumber : '',
					},
				];
			}

			this.audits = data.audits;
			this.loadUsers(this.entity.productId);
		} catch (e) {
			console.log('Error:', e);
			// this.product = null;
		} finally {
			this.loading = false;
		}
	}

	private hasSimproRemovalJobReason() {
		return this.simproJobs?.find((simproJob: SimproJobDetails) => {
			return simproJob.jobType === ProductSimProJobTypeEnum.Remove && simproJob.reason != null;
		});
	}

	public statusChangeReasonOptions(removal: boolean) {
		return this.hasSimproRemovalJobReason()
			? []
			: (isLastEntityOnProduct(this.product)
					? StatusChangeReasonsLastEntity
					: removal
					? StatusChangeReasonsRemoval
					: StatusChangeReasonsCancel
			  ).map(val => ({ value: val, text: val }));
	}

	public async deactivateEntity(params: { modalId: string; actionReason?: string | null }) {
		try {
			const id = this.entityId;
			const body = {
				actionReason: params.actionReason ?? undefined,
			};
			switch (this.entityType) {
				case 'water_meters':
					await this.waterMetersApi.deactivateWaterMeter(id, body);
					// (id, entity as WaterMeterInfo);
					break;
				case 'water_tanks':
					await this.waterTanksApi.deactivateWaterTank(id, body);
					break;
				case 'water_monitors':
					await this.waterMonitorsApi.deactivateWaterMonitor(id, body);
					break;
			}
			this.$bvModal.hide(params.modalId);
		} catch (e) {
			let error;
			if (e.response) {
				error =
					this.entityTypeDisplayString +
					' not deactivated ' +
					JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = this.entityTypeDisplayString + ' not deactivated, network Error';
			} else {
				error = this.entityTypeDisplayString + ' not deactivated, unknown Error';
			}
			new Toast().makeToast(
				error,
				'Error Deactivating ' + this.entityTypeDisplayString,
				'danger',
				false,
			);
			return;
		}
		setTimeout(() => {
			new Toast().makeToast(
				this.entityTypeDisplayString + ' Deactivated',
				this.entityTypeDisplayString + ' Deactivated',
				'success',
				false,
			);
			this.$emit('loadProduct', this.entityId);
			this.loadEntity();
		}, 1000);
	}

	public async cancelEntity(params: { modalId: string; actionReason?: string | null }) {
		try {
			const id = this.entityId;
			const body = {
				actionReason: params.actionReason ?? undefined,
			};
			switch (this.entityType) {
				case 'water_meters':
					await this.waterMetersApi.cancelWaterMeter(id, body);
					break;
				case 'water_tanks':
					await this.waterTanksApi.cancelWaterTank(id, body);
					break;
				case 'water_monitors':
					await this.waterMonitorsApi.cancelWaterMonitor(id, body);
					break;
			}
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(
				error,
				'Error Cancelling ' + this.entityTypeDisplayString,
				'danger',
				false,
			);
			return;
		}
		setTimeout(() => {
			new Toast().makeToast(
				this.entityTypeDisplayString + ' Cancelled',
				this.entityTypeDisplayString + ' Cancelled',
				'success',
				false,
			);
			this.$emit('loadProduct', this.entityId);
			this.loadEntity();
			this.$bvModal.hide(params.modalId);
		}, 1000);
	}
	public classicTransceiver = false;

	public isItAClassicTransceiver(transceiver: Transceiver) {
		if (transceiver) {
			this.classicTransceiver =
				transceiver.type === null
					? false
					: ['00', '03', '04'].includes(transceiver.type.toString()) &&
					  transceiver.principalId === null;
		}
	}

	public readyForSignOff() {
		this.isItAClassicTransceiver(this.entity.transceiver);
		if (
			this.entity.status !== 'install' ||
			((this.entityType === 'water_tanks'
				? ![
						this.entity.nominal,
						this.entity.height,
						this.entity.offset,
						this.entity.entitylocation?.latitude,
						this.entity.entitylocation?.longitude,
						this.entity.billingTier,
						this.productPlan,
				  ].includes(null) &&
				  (this.classicTransceiver === true ||
						![this.entity.sensor, this.entity.transceiver].includes(null))
				: ![
						this.entity.litresPerPulse,
						this.entity.entitylocation?.latitude,
						this.entity.entitylocation?.longitude,
						this.entity.billingTier,
						this.productPlan,
				  ].includes(null)) &&
				(this.classicTransceiver === true ||
					![this.entity.sensor, this.entity.transceiver].includes(null)))
		) {
			return false;
		} else {
			return true;
		}
	}

	public moveEntityToSignOff() {
		let response;
		try {
			const api = new ProductsApi();
			response = api.changeProductStatus(this.entity.productId, this.entityType, this.entity.id, {
				newStatus: 'sign-off',
			});
		} catch (e) {
			let error;
			if (e.response) {
				error =
					`${this.entityType} not moved to sign off ` +
					JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = `${this.entityType} not moved to sign off , network Error`;
			} else {
				error = `${this.entityType} not moved to sign off , unknown Error`;
			}
			new Toast().makeToast(error, `Error moving ${this.entityType} to sign off`, 'danger', false);
			return;
		}
		setTimeout(() => {
			new Toast().makeToast(
				`${this.entityType} moved to sign off`,
				`${this.entityType}  moved to sign off`,
				'success',
				false,
			);
			this.$emit('loadProduct', this.entityId);
			this.loadEntity();
		}, 1000);
	}

	public async signOff(params: { modalId: string }) {
		try {
			const id = this.entityId;
			switch (this.entityType) {
				case 'water_meters':
					await this.waterMetersApi.signoffWaterMeter(id);
					break;
				case 'water_tanks':
					await this.waterTanksApi.signoffWaterTank(id);
					break;
				case 'water_monitors':
					await this.waterMonitorsApi.signoffWaterMonitor(id);
					break;
			}
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(
				error,
				'Error Signing Off ' + this.entityTypeDisplayString,
				'danger',
				false,
			);
			return;
		}
		setTimeout(() => {
			new Toast().makeToast(
				'Water ' + this.entityTypeDisplayString + ' Signed Off',
				'Success',
				'success',
				false,
			);
			this.$emit('loadProduct', this.entityId);
			this.loadEntity();
			this.$bvModal.hide(params.modalId);
		}, 1000);
	}

	public async loadUsers(productId: number | string) {
		const productsApi = new ProductsApi();
		const { data } = await productsApi.getProductById(parseInt(productId, 10), {
			params: { include: 'users' },
		});
		this.users = data.users;
		this.users.forEach(user => {
			this.form.users.push(Object.assign({ checked: false, sms: false, id: user.id }, user));
		});
	}

	public async created() {
		this.loading = true;
		await this.loadEntity();
		this.loading = false;
	}

	public buildSeries() {
		return this.entitySeries[this.entityType];
	}

	public get entityTypeAlternate() {
		return WaterEntityUtil.convertEntityType(this.entityType);
	}

	public get entityDisplayName() {
		return WaterEntityUtil.getEntityTypeSingularDisplayName(this.entityType);
	}

	public entityHasCorrection(): boolean {
		return !isWaterMeterEntity(this.entityType) || this.entityCorrections.length > 0;
	}
}
